import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isNull, isEqual, isArray } from "lodash";

import {cloneObject, getParam} from '../utils/utils';

import dsd from '../classes/clsDSD';

import * as PD from '../classes/pdStyle';

import Buffering from "../components/Buffering"; 

import { listSolutions, listCapabilities, getCapability } from "../utils/utilsSolution";



class SelectCapability extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            renderState: null
        };

        this.dsd = new dsd();
        this.dsd.StateObject = this;

        this.handleChange = this.handleChange.bind(this);
    

    }

    componentDidMount(){

        this.setup();
 
     }
 
     componentDidUpdate(prevProps, prevState){
 
        if (!isEqual(this.props, prevProps)){
            this.setup();
        }

    
    }
 

    setup(){

        let StateChange = {
            renderState: null,
            selectSolution: false,
            label: "Capability",
            idSelected: "",
            idSolution: null,
            idSystem: null,
            type: null,
            onChange: null,
        }

        StateChange.name = getParam('name', this.props);

        if (getParam('label',this.props)){
            StateChange.label = getParam('label',this.props);
        }

        StateChange.selectSolution = getParam('selectSolution',this.props);
        StateChange.idSolution = getParam('idSolution', this.props);
        StateChange.idSystem = getParam('idSystem', this.props);
        StateChange.type = getParam('type', this.props);
        StateChange.idSelected = getParam('value', this.props);

        StateChange.onChange = getParam('onChange', this.props);

        
        if (StateChange.selectSolution){
            this.loadSolutions();
        }


        if (StateChange.idSelected){
            this.loadSelectedCapability(StateChange.idSelected);
        }

        this.setState(StateChange, () => {
            if (this.state.idSolution){
                this.loadCapabilities();
            }
        })

    }

    loadSelectedCapability(idCapability){

        if (!idCapability){
            return;
        }

        this.setState({renderState: "loading"});

        const onLoad = (Capability) => {
            const StateChange = {
                SelectedCapability: Capability,
                renderState: "loaded"
            };
            
            if (Capability.Solution){
                StateChange.idSolution = Capability.Solution._id;
            }
            
            this.setState(StateChange, () => {
                if (this.state.idSolution){
                    this.loadCapabilities();
                }
            });

        };

        const onFail = (error) => {
            this.setState({
                renderState: "failed",
                errorMessage: error.message || "Failed to load capability"
            });
        };

        getCapability(this.dsd, idCapability, onLoad, onFail);

        return;               
    };



    loadCapabilities(){

        const idSolution = this.state.idSolution;
        const idSystem = this.state.idSystem;
        const filters = {};

        if (idSolution) {
            filters.idSolution = idSolution;
        }

        if (idSystem) {
            filters.idSystem = idSystem;
        }

        if (this.state.type) {
            filters.type = this.state.type;
        }



        const onLoad = (data) => {
            this.setState({
                isLoadedCapabilities: true,
                renderState: 'loaded',
                Capabilities: data
            });

        }
    
        const onFail = (error) => {
            this.setState({
                isFailed: true,
                isLoadedCapabilities: false
            });
        }

        this.setState({renderState: 'loading'})
        listCapabilities(this.dsd, filters, onLoad, onFail);
        
        return;            
    };


    loadSolutions(){

        const onLoad = (data) => {
            this.setState({
                isLoadedSolutions: true,
                renderState: 'loaded',
                Solutions: data
            });

        }
    
        const onFail = (error) => {
            this.setState({
                isFailed: true,
                isLoadedSolutions: false
            });
        }

        this.setState({renderState: 'loading'})
        listSolutions(this.dsd, {}, onLoad, onFail);
        return;
        
    };


    handleChange(event) {

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        switch (FormFieldName){
            case "idSolution":
                this.setState({"idSolution":FormFieldValue}, () => {
                    if (this.state.idSolution){
                        this.loadCapabilities();
                    }
                });
                break;
            default:
                let FormData = this.state.FormData;
                FormData[FormFieldName] = FormFieldValue;
                this.setState({"FormData": FormData});
                break;
        };

    };


    render() {

        switch (this.state.renderState){
            case "invalid":
            case "failed":
            case "denied":
                let Message = "An error has occured";
                if (this.state.errorMessage){
                    Message = this.state.errorMessage;
                }
                return <PD.ErrorBox>{Message}</PD.ErrorBox>
                break;
            case "loading":
                return <Buffering/>
                break;
            case "cancelled":
                return <p>Cancelled</p>
                break;
            case "loaded":

                return(
                    <>                    

                        {this.state.selectSolution && this.state.isLoadedSolutions &&
                            <PD.Select label='Select a Solution' name='idSolution' onChange={this.handleChange} value={this.state.idSolution}>
                                {
                                    this.state.Solutions.map(
                                        (Solution, pos) => 
                                            {
                                                return(
                                                    <option key={pos} value={Solution._id}>{Solution.name}</option>
                                                )
                                            }
                                    )
                                }
                            </PD.Select>
                        }


                        {this.state.isLoadedCapabilities &&

                            <PD.Select label={this.state.label} name={this.state.name} onChange={this.state.onChange} value={this.state.idSelected}>
                                {
                                    this.state.Capabilities.map(
                                        (Capability, pos) => 
                                            {
                                                return(
                                                    <option key={pos} value={Capability._id}>{Capability.name}</option>
                                                )
                                            }
                                    )
                                }
                            </PD.Select>
                        }

                    </>
                )
        }

    }
}


export default function SelectCapability_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <SelectCapability {...props} navigation={navigation} location={location} params={params} />;
  }
